import React from 'react';
import { securityData } from '@/data/mock';
import { Lock, Users, FileText, Eye, ShieldCheck } from 'lucide-react';

const iconMap = {
  Lock,
  Users,
  FileText,
  Eye,
};

export const SecuritySection = () => {
  return (
    <section id="security" className="relative py-24 bg-slate-950">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900/50" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-3xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center">
                  <ShieldCheck size={24} className="text-cyan-400" />
                </div>
                <span className="text-cyan-400 font-medium">Security & Compliance</span>
              </div>
              
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                {securityData.title}
              </h2>
              <p className="text-slate-400 text-lg">
                {securityData.subtitle}
              </p>
            </div>
            
            {/* Right - Features grid */}
            <div className="grid grid-cols-2 gap-4">
              {securityData.features.map((feature, index) => {
                const Icon = iconMap[feature.icon];
                return (
                  <div
                    key={index}
                    className="p-5 bg-slate-800/30 border border-slate-700/30 rounded-xl"
                  >
                    <Icon size={20} className="text-cyan-400 mb-3" />
                    <p className="text-white text-sm font-medium">{feature.title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
